import { observer } from "mobx-react-lite";
import Modal from "react-modal";
import styles from "../../License.module.css";
import LicenseFormFields from "../licenseFormFields";

const createLicenseModal = ({ isOpenModal, setIsOpenModal, onSubmit }) => {
  const initialValues = {
    license_description: "",
    insurance_type: "Liability",
    policy_number: "",
    account_number: "",
    exp_date: "",
    cost: 0.0,
    paid: false,
    descript_ops: "",
    certificate_holder: "",
    filename: null,
  };

  return (
    <Modal
      isOpen={isOpenModal}
      onRequestClose={() => setIsOpenModal(!isOpenModal)}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: "4000",
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          zIndex: "130",
          overflow: "auto",
          maxHeight: "80%",
          width: "90%",
        },
      }}
    >
      <div>
        <span
          onClick={() => setIsOpenModal(!isOpenModal)}
          className={styles.closeBtn}
        >
          &#x2715;
        </span>
        <h3>Create New License</h3>
        <div>
          <LicenseFormFields
            initialValues={initialValues}
            onSubmit={onSubmit}
          />
        </div>
      </div>
    </Modal>
  );
};

export default observer(createLicenseModal);
